import {bindable, bindingMode} from "aurelia-framework";

export class PageAlert{

    @bindable({ defaultBindingMode: bindingMode.oneWay }) message: string;

    constructor() {
    }

}